<template>
<div class="CreateTechniqueDiv">
   <div class="container-fluid">
      <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-1Perc margin-top-1Perc cursor-pointer" v-on:click="updateCloseTechniqueOverlayFlag($event,false)">
                    <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="row col-md-2 col-lg-2"></div>
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Technique Name
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <input type="text" class="form-control" v-model="techniqueObj.TechniqueName">
                        </div>
                    </div>
                </div>
                <div class="row col-md-3 col-lg-3"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="row col-md-2 col-lg-2"></div>
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Aliases
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <input type="text" class="form-control" v-model="techniqueObj.Aliases">
                        </div>
                    </div>
                </div>
                <div class="row col-md-3 col-lg-3"></div>
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <!-- ToDo: Track this -->
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="createTechnique">Create Technique</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <loader></loader>   
 </div>
 </div>
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import { techniqueService } from '@/server-util/technique-service'
export default {
  created: function () {},
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      techniqueObj: {
        TechniqueName: '',
        Aliases: '',
        Category: 0
      }
    }
  },
  name: 'CreateTechniqueDiv',
  methods: {
    updateCloseTechniqueOverlayFlag: function (event, flagToUpdate) {
      this.$emit('openOverlay', flagToUpdate)
    },
    createTechnique: function () {
      var storeObj = this.$store
      // var _this = this
      if (this.validateRequiredFieldBeforeSubmit()) {
        if (
        this.techniqueObj !== undefined || this.techniqueObj !== null
        ) {
          // AK: Start showing Spinner
          // this.showSpinner = true
          this.$store.state.isLoading = true
          techniqueService
            .createTechnique(
              storeObj.state.access_token,
              this.techniqueObj
            )
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Hide showing Spinner
                // this.showSpinner = false
                this.$store.state.isLoading = false
                // AK: Store it
                storeObj.state.techniqueList.push(responseObj.data)
                // AK: Hide Create Technique Overlay
                this.$emit('openOverlay', false)
              } else {
                // AK: Hide Spinner
                // this.showSpinner = false
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              // AK: Hide Spinner
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Technique Object is NULL hence declined CREATE TECHNIQUE'
          )
        }
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    validateRequiredFieldBeforeSubmit: function () {
      if (this.techniqueObj.TechniqueName === '' || this.techniqueObj.TechniqueName.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Name can\'t be empty.'
        return false
      } else if (this.techniqueObj.Aliases === '' || this.techniqueObj.Aliases.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Aliases can\'t be empty.'
        return false
      }
      return true
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader
  }
}
</script>

<style scoped>
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 25%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
</style>





// WEBPACK FOOTER //
// src/components/CreateTechniqueOverlay.vue